// extracted by mini-css-extract-plugin
export default {"loader":"ProgressLoader_loader__fDJX5","loader__box":"ProgressLoader_loader__box__t0Dc3","jump_4123":"ProgressLoader_jump_4123__trhiW"};